import { useEffect, useState } from 'react';

export default function LoadingScreen({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const duration = 2000;
    const interval = 20;
    const increment = 100 / (duration / interval);
    
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => setFadeOut(true), 300);
          setTimeout(() => onComplete?.(), 800);
          return 100;
        }
        return prev + increment;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <div 
      className={`loading-screen transition-opacity duration-500 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
      style={{ pointerEvents: fadeOut ? 'none' : 'auto' }}
    >
      {/* Floating particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-[#722F37] rounded-full opacity-40"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `floating ${4 + Math.random() * 4}s ease-in-out infinite`,
              animationDelay: `${Math.random() * 2}s`
            }}
          />
        ))}
      </div>

      <div className="relative z-10 text-center">
        {/* Logo */}
        <div className="mb-4 flex justify-center">
          <img
            src="/logo-white.png"
            alt="Ciro Gallotti — L'Arte del Gioiello"
            className="h-28 md:h-36 w-auto object-contain animate-fade-in"
          />
        </div>
        <p className="text-white/40 text-sm uppercase tracking-[0.4em] mb-10">
          L'Arte del Gioiello
        </p>

        {/* Progress bar */}
        <div className="w-56 mx-auto">
          <div className="loading-bar">
            <div 
              className="loading-bar-inner"
              style={{ width: `${progress}%`, transition: 'width 0.1s linear' }}
            />
          </div>
          <p className="text-white/20 text-xs mt-4 font-mono tracking-widest">
            {Math.round(progress)}%
          </p>
        </div>
      </div>

      {/* Corner decorations */}
      <div className="absolute top-10 left-10 w-20 h-20 border-l-2 border-t-2 border-[#722F37]/30 rounded-tl-3xl" />
      <div className="absolute top-10 right-10 w-20 h-20 border-r-2 border-t-2 border-[#722F37]/30 rounded-tr-3xl" />
      <div className="absolute bottom-10 left-10 w-20 h-20 border-l-2 border-b-2 border-[#722F37]/30 rounded-bl-3xl" />
      <div className="absolute bottom-10 right-10 w-20 h-20 border-r-2 border-b-2 border-[#722F37]/30 rounded-br-3xl" />
    </div>
  );
}
